/* eslint-disable react-hooks/exhaustive-deps */
import { SDateField, SFrame, SLabel, SText } from "components";
import {
  B000ShokaKbn,
  getSCode,
  JuchuKbn,
  JuchuStatus,
  SCode,
} from "messages/codes";
import { B000140, B000150 } from "pages";
import { createRef, useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { focusState, SDialogContext, useFocus } from "states";
import { SCancelButton } from "./buttons/SCancelButton";
import { SNormalButton } from "./buttons/SNormalButton";
import { SCodeCheck } from "./checks/SCodeCheck";
import { SConfirmDialog } from "./dialogs/SConfirmDialog";
import { SMultiDialog } from "./dialogs/SMultiDialog";
import { SNumberField } from "./fields/SNumberField";
import { STextField } from "./fields/STextField";
import { SFileField } from "./fields/SFileField";
import { SCodeSelect } from "./selects/SCodeSelect";
import { SValueSelect } from "./selects/SValueSelect";
import { SEntryTab } from "./tabs/SEntryTab";
import { B000140Get, getFormData, RestClient } from "clients/rest";
import { STextArea } from "./fields/STextArea";
import { outputText, yearMonth } from "services";
import { Column } from "@material-table/core";
import { STable } from "./tables/STable";
import { STextCell } from "./tables/STextCell";
import { SNumberCell } from "./tables/SNumberCell";
import { SProgress } from "./parts/SProgress";
import { progressState } from "states/progressState";

type Fields = Partial<{
  tab: boolean;
  date1: string;
  date2: string;
  date3: string;
  code: string;
  text1: string;
  text2: string;
  check1: string;
  select1: SCode;
  select2: SCode;
  dialog1: string;
  dialog2: string;
}>;

const defaultValues: Fields = {
  tab: true,
  date1: "",
  date2: "",
  date3: "",
  code: "1111111",
  text1: yearMonth(),
  text2: "",
  check1: "1",
  select1: getSCode(B000ShokaKbn, "0"),
  select2: getSCode(JuchuStatus, "1"),
  dialog1: "",
  dialog2: "",
};

const focusId = "Components";

export const Components = () => {
  useFocus(focusId);
  return <Page />;
};

const Page = () => {
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues,
  });
  const { focus, register } = useRecoilValue(focusState(focusId));

  const setProg = useSetRecoilState(progressState);

  useEffect(() => {
    focus(1);
  }, []);

  return (
    <FormProvider {...methods}>
      <SFrame title="コンポーネント" gridTemplateColumns="10rem 10rem 10rem">
        <SLabel>日付1</SLabel>
        <SDateField name="date1" label="日付1" {...register(1)} />
        <SText>{methods.watch("date1")}</SText>
        <SLabel>日付2</SLabel>
        <SDateField name="date2" label="日付2" {...register(2)} />
        <SText>{methods.watch("date2")}</SText>
        <SLabel>日付3</SLabel>
        <SDateField name="date3" label="日付3" {...register(3)} />
        <SText>{methods.watch("date3")}</SText>
        <SLabel>数値</SLabel>
        <SNumberField
          name="code"
          {...register(4)}
          label="数値1"
          size={4}
          dialog={<B000140 />}
          // handleSubmit={handleSubmit}
          disabled
        />
        <SText>{methods.watch("code")}</SText>
        <SLabel>数値</SLabel>
        <SNumberField
          name="code"
          {...register(5)}
          label="数値2"
          code
          dialog={<B000150 />}
          handleSubmit={(data: any) => {}}
        />
        <SText>{methods.watch("code")}</SText>
        <SLabel>テキスト1</SLabel>
        <STextField
          name="text1"
          label="テキスト1"
          {...register(6)}
          size={6}
          required
        />
        <SText>{methods.watch("text1")}</SText>
        <SLabel>テキスト2</SLabel>
        <STextField
          name="text2"
          label="テキスト2"
          {...register(7)}
          size={14}
          required
          location
        />
        <SText>{methods.watch("text2")}</SText>
        <SLabel>チェックボックス</SLabel>
        <SCodeCheck
          name="check1"
          label="チェック1"
          {...register(8)}
          on={"1"}
          off={"0"}
        />
        <SText>{methods.watch("check1")}</SText>
        <SLabel>コード選択</SLabel>
        <SCodeSelect
          name="select1"
          label="セレクトボックス1"
          {...register(9)}
          options={B000ShokaKbn}
          empty
          required
        />
        <SText>{methods.watch("select1")?.value}</SText>
        <SLabel>値選択</SLabel>
        <SValueSelect
          name="select2"
          label="セレクトボックス2"
          {...register(10)}
          options={JuchuStatus}
        />
        <SText>{methods.watch("select2")?.value}</SText>
        <SLabel gridColumn="span 3">タブ</SLabel>
        <SEntryTab name="tab" gridColumn="span 2" />
        <SNormalButton
          label="編集"
          {...register(11)}
          onClick={() => {
            methods.setValue("tab", false);
          }}
        />
        <SLabel gridColumn={1}>確認ダイアログ</SLabel>
        <SNormalButton
          label="確認"
          dialog={
            <SConfirmDialog
              title="受注キャンセル"
              msg="選択中の受注データをキャンセルします。よろしいですか？"
            />
          }
          dialogAction="confirm"
          handleSubmit={() => {
            methods.setValue("dialog1", "confirmed");
          }}
        />
        <SText>{methods.watch("dialog1")}</SText>
        <SLabel gridColumn={1}>ダイアログ</SLabel>
        <SNormalButton
          label="OK/NG"
          dialog={
            <SMultiDialog
              title="受注データ複製"
              msg="新規作成する受注データに引き継ぐ対象を選択してください。"
              events={[
                {
                  label: "受注ヘッダのみ",
                  handleSubmit: () => {
                    methods.setValue("dialog2", "head only");
                  },
                },
                {
                  label: "受注ヘッダ+受注明細",
                  handleSubmit: () => {
                    methods.setValue("dialog2", "all");
                  },
                },
              ]}
            />
          }
          dialogAction="close"
        />
        <SText>{methods.watch("dialog2")}</SText>
        <SNormalButton
          label="プログレス"
          onClick={() => {
            setProg(true);
            setTimeout(() => setProg(false), 2000);
          }}
        />
      </SFrame>
      <SProgress />
    </FormProvider>
  );
};

export const Components2 = () => {
  const focusId = "Components";
  useFocus(focusId);
  return <SubComponents />;
};
const SubComponents = () => {
  type Fields = Partial<{
    date1: string;
    text1: string;
    text2: string;
    select1: SCode;
  }>;
  const defaultValues: Fields = {
    date1: "",
    text1: "",
    text2: "",
    select1: getSCode(JuchuKbn, "0"),
  };

  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues,
  });

  const focusId = "Components";
  const { focus, register } = useRecoilValue(focusState(focusId));

  useEffect(() => {
    focus(1);
  });

  return (
    <FormProvider {...methods}>
      <SFrame>
        <SDateField name="date1" label="日付1" {...register(1)} />
        <STextField
          name="text1"
          {...register(2)}
          dialog={<B000140 />}
          handleSubmit={() => {}}
        />
        <STextField name="text2" {...register(3)} />
        <SCodeSelect
          name="select1"
          label="セレクトボックス1"
          {...register(9)}
          options={B000ShokaKbn}
          empty
          required
        />
        <SNormalButton
          label="ダイアログ"
          dialog={<DialogTest />}
          handleSubmit={(data: any) => {
            methods.setValue("text1", data.text1);
            methods.setValue("text2", data.text2);
            focus(2);
          }}
        />
        <SCancelButton
          label="キャンセル"
          onClick={() => {
            methods.reset();
          }}
          handleSubmit={() => {}}
        />
        <SNormalButton label="担当者照会" dialog={<B000140 />} />
      </SFrame>
    </FormProvider>
  );
};

const DialogTest = () => {
  const focusId = "DialogTest";
  useFocus(focusId);
  return <SubDialogTest />;
};
const SubDialogTest = () => {
  type Fields = {
    text1: string;
    text2: string;
  };
  const defaultValues: Fields = {
    text1: "",
    text2: "",
  };

  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues,
  });

  const focusId = "DialogTest";
  const { focus, register } = useRecoilValue(focusState(focusId));

  const handleSubmit = useContext(SDialogContext);

  useEffect(() => {
    focus(1);
  });

  return (
    <FormProvider {...methods}>
      <SFrame>
        <STextField name="text1" {...register(1)} />
        <STextField name="text2" {...register(2)} />
        <SNormalButton
          label="実行"
          onClick={() => {
            handleSubmit(methods.getValues());
          }}
        />
      </SFrame>
    </FormProvider>
  );
};

const components3Id = "components3Id";

export const Components3 = () => {
  useFocus(components3Id);
  return <FileText />;
};

const FileText = () => {
  type Fields = Partial<{
    excelFileData: File;
    textArea: string;
    idoYmd: string;
    shainCd: string;
    bumonCd: string;
    haraisokoCd: string;
    ukesokoCd: string;
  }>;
  const defaultValues: Fields = {
    excelFileData: undefined,
    textArea: "row1\nrow2",
    idoYmd: "20220310",
    shainCd: "9999",
    bumonCd: "110",
    haraisokoCd: "001",
    ukesokoCd: "002",
  };
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues,
  });

  const { register } = useRecoilValue(focusState(components3Id));

  type Params = {
    excelFileData: File;
    idoYmd: string;
    shainCd: string;
    bumonCd: string;
    haraisokoCd: string;
    ukesokoCd: string;
  };

  const handleClick = () => {
    const fields = methods.getValues();
    console.log(fields);
    // 矯正アンラップはNG
    const parmas: Params = {
      excelFileData: fields.excelFileData!,
      idoYmd: fields.idoYmd!,
      shainCd: fields.shainCd!,
      bumonCd: fields.bumonCd!,
      haraisokoCd: fields.haraisokoCd!,
      ukesokoCd: fields.ukesokoCd!,
    };
    const formData = getFormData(parmas);

    RestClient.post("b090060/import/sokohonsha", formData)
      .then((value) => {
        console.log(value);
      })
      .catch((reason) => {
        console.log(reason);
      });
  };

  const handleDL = () => {
    const text = methods.getValues().textArea;
    if (typeof text === "undefined") return;
    outputText(text, "テキストエリア.txt");
  };

  return (
    <FormProvider {...methods}>
      <SFrame gridTemplateColumns="30rem" rowGap="1rem">
        <SFileField
          name="excelFileData"
          label="テストファイル"
          type="csv"
          height="10rem"
        />
        <SNormalButton label="取込" onClick={handleClick} />
        <STextField name="shainCd" {...register(1)} />
        <STextField name="bumonCd" {...register(2)} />
        <STextArea name="textArea" height="5rem" {...register(3)} />
        <STextArea name="textArea" height="10rem" disabled />
        <SNormalButton label="DL" onClick={handleDL} />
      </SFrame>
    </FormProvider>
  );
};

export const Components4 = () => {
  type Data = Partial<{
    gyoNo: number;
    cd: string;
    number: number;
    nm: string;
  }>;
  const columns: Column<Data>[] = [
    { field: "gyoNo", title: "ID", editable: "never" },
    {
      field: "cd",
      title: "コード",
      editComponent: (props) => (
        <SNumberCell
          editProps={props}
          size={7}
          code
          dialog={<B000140 />}
          onBlur={(e) => {
            B000140Get({ shainCd: e.currentTarget.value }).then((response) => {
              props.onRowDataChange({
                ...props.rowData,
                nm: response.data.shainNm,
              });
            });
          }}
          handleSubmit={(data: any) => {
            props.onRowDataChange({
              ...props.rowData,
              cd: data.shainCd,
              nm: data.shainNm,
            });
          }}
        />
      ),
    },
    {
      field: "number",
      title: "数値",
      editComponent: (props) => (
        <SNumberCell editProps={props} size={6} scale={2} />
      ),
    },
    {
      field: "nm",
      title: "名称",
      editComponent: (props) => (
        <STextCell editProps={props} value={props.rowData.nm} size={10} />
      ),
    },
    { field: "nm", title: "名称(入力不可)", editable: "never" },
  ];

  const [data, setData] = useState<Data[]>([]);

  const tableRef = createRef<any>();

  const handleClick = () => {
    setData([
      { gyoNo: 11, cd: "001", nm: "テスト" },
      { gyoNo: 21, cd: "002", nm: "テスト" },
      { gyoNo: 31, cd: "003", nm: "テスト" },
      { gyoNo: 41, cd: "004", nm: "テスト" },
      { gyoNo: 51, cd: "005", nm: "テスト" },
      { gyoNo: 61, cd: "006", nm: "テスト" },
    ]);
  };

  const handleProc = () => {
    console.log(data);
    console.log(tableRef.current);
  };

  // useEffect(() => {
  //   handleClick();
  // }, []);

  return (
    <SFrame>
      <STable
        keyName="gyoNo"
        columns={columns}
        data={data}
        tableRef={tableRef}
        edit={true}
      />
      <SNormalButton label="検索" onClick={handleClick} />
      <SNormalButton label="処理" onClick={handleProc} />
    </SFrame>
  );
};
